module.exports = __webpack_public_path__ + "static/media/left-arrow.541cc2c1.svg";